import React from 'react';

import SearchFTUXIcon from '@/components/Icons/icons/SearchFTUXIcon';

import './styles/newFtuxForSearch.scss';

interface NewFTUXForSearchInterface {
  text: string | React.ReactNode;
  className?: string;
  icon?: string | React.ReactNode;
  iconColor?: string;
}

const NewFTUXForSearch: React.FC<NewFTUXForSearchInterface> = ({ text, className, icon, iconColor = '#424242' }) => {
  return (
    <div className={`search-ftux-container ${className}`}>
      {icon ? icon : <SearchFTUXIcon color={iconColor} />}
      <p className="search-ftux-text">{text}</p>
    </div>
  );
};

export default NewFTUXForSearch;
